import React, { useEffect, useState } from "react";
import "./review.scss";
import PersonalColumn from "./PersonalColumn";
import AddressColumn from "./AddressColumn";
import IncomeColumn from "./IncomeColumn";
import EducationColumn from "./EducationColumn";
import Declaration from "../Declaration";
import BtnSet from "../IdfcLetterHead/BtnSet";
import FooterText from "../modules/FooterText";
import { GetBaseUrl } from "../modules/getBaseUrl";
import { useDispatch, useSelector } from "react-redux";
import { addTokenInfo } from "../LoginPage/redux/actions";
import { api } from "../../Services";

function Review() {
  const [boxes, setBoxes] = useState({});
  const tokenData = useSelector((state) => state.tokens.tokens);
  let url = window.location.href;
  let baseUrl = GetBaseUrl(url);
  const dispatch = useDispatch();
  // if (tokenData.applicationStatus !== "Registered") {
  //   window.location.replace(baseUrl + "/application/app-preview");
  // }
  const setBoxData = (e) => {
    setBoxes(e);
  };
  const getDocs = async () => {
    try {
      const docs1 = await api.getDocuments(
        "application",
        tokenData.applicationData.id,
        tokenData.token
      );
      dispatch(addTokenInfo(["docs", docs1.data]));
      return docs1;
    } catch (err) {
      console.log("err", err);
    }
  };

  useEffect(() => {
    getDocs();
  }, []);
  console.log('final review check', tokenData)
  return (
    <div className="form-div review">
      <div className="review-heading">
        <div className="form-title">Review and Submit Application</div>
        <div className="sub-title">
          Please review your details before submit{" "}
        </div>
      </div>
      <PersonalColumn />
      {/* <AddressColumn /> */}
      <IncomeColumn />
      <EducationColumn />
      <Declaration onChange={(e) => setBoxData(e)} />
      {tokenData.applicationStatus === "Registered" && <BtnSet boxes={boxes} />}
      <FooterText />
    </div>
  );
}

export default Review;
